import React from 'react'
import styled from 'styled-components/macro'
import estyled from '@emotion/styled'
import { getGelTokens } from '@tal-gel/theming'
import { GelHeading4, GelParagraph } from '@tal-gel/components'

import rewards from './assets/rewards.svg'
import prezee from './assets/prezee.jpg'

const Component = styled.div`
  position: relative;
  background-color: ${() => getGelTokens().brand.brandColorGrayT05};
  padding: 80px 20px;
  display: flex;
  justify-content: center;

  @media only screen and (min-width: 768px) {
    padding: 134px 24px 0;
  }
`

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    max-width: 1032px;
    justify-content: space-between;
    width: 100%;
  }
`

const Content = styled.div`
  max-width: 520px;
  order: 1;

  @media only screen and (min-width: 768px) {
    max-width: 400px;
  }
`

const Image = styled.img`
  width: calc(100% + 18px - 24px - 24px);
  max-width: 327px;
  margin-bottom: 54px;

  @media only screen and (min-width: 768px) {
    position: relative;
    transform: none;
    width: 100%;
    left: 0;
    top: -40px;
    max-width: 500px;
    order: 2;
    margin-bottom: 0;
  }
`

const GelParagraphColored = estyled(GelParagraph)`
  color: ${() => getGelTokens().brand.brandColorGrayT50};
  font-weight: 400;

  & > span {
    color: ${() => getGelTokens().brand.brandColorBlack};
  }
`

const Rewards = ({ demo }) => (
  <Component>
    <InnerWrapper>
      <Content>
        <GelHeading4 marginBottom={12}>Your rewards</GelHeading4>
        <GelParagraphColored large>
          Good health is its own reward, but to thank you for taking proactive
          health steps we’ll send you a <span>$10 gift card</span> that can be
          used at selected Australian retailers including <span>Rebel</span>,{' '}
          <span>Anaconda</span> and <span>BCF</span>.
        </GelParagraphColored>
      </Content>
      <Image src={demo ? prezee : rewards} alt='Your rewards' />
    </InnerWrapper>
  </Component>
)

export default Rewards
